import { enviaMsgErro, mostraMensagemErro } from "../helpers/Notificacoes";

export function tratarErroRequisicao(error: any, path: string, onAuthError?: () => void) {

    const redirecionarParaLogin = () => {
        if (onAuthError) {
            onAuthError();
            return;
        } else {
            window.location.replace('/');
        }
    };

    // 1. O servidor respondeu com status de erro
    if (error.response) {
        const status = error.response.status;
        const data = error.response.data;
        const errorMessage = data?.message?.message || data?.message || error.response.statusText || "Erro na requisição";

        // Se falhar na autenticação
        if (status === 401 || status === 403) {
            console.warn("Sessão expirada ou acesso negado. Realizando logoff.");
            localStorage.removeItem('stbs');

            mostraMensagemErro("Sessão expirada ou acesso negado. Realizando logoff.", undefined, redirecionarParaLogin);
        }

        return enviaMsgErro(status, errorMessage);
    }

    // 2. Erro de Timeout / Cancelamento por sinal
    if (error.name === 'CanceledError' || error.name === 'AbortError') {
        return enviaMsgErro(408, `Tempo limite excedido ao chamar ${path}`);
    }

    // 3. Qualquer outro erro de rede ou desconhecido
    console.error(`Erro na requisição para ${path}:`, error);
    return enviaMsgErro(500, error.message || "Ocorreu um erro inesperado.");
}